import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { EditResponsibleCrubs } from 'practice/constants/responsabile-crubs';
import FormResponsible, { FormResponsibleVM } from 'practice/components/resonsible/form';
import { HttpResponse } from 'shell/models/http-response';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ResponsibleData } from 'shell/models/type-responsible';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';
import { responsibleResponseTransformer } from 'practice/utils/responsible-response-transformer';

const EditResponsible = (): ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-responsabile');
  });

  const [responsible] = useHttpFetch<HttpResponse<ResponsibleData>, FormResponsibleVM>(
    `${__PRACTICE_API_URL__}/pratiche/responsabile/${params?.tyPratica}-${params?.codServizio}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: responsibleResponseTransformer,
    }
  );

  const updateResponsible = useHttpClient(`${__PRACTICE_API_URL__}/pratiche/responsabile/`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback(
    (values: FormResponsibleVM) => {
      (
        updateResponsible({
          data: {
            codResponsabile: values.responsible || undefined,
            key: {
              tipoPratica: values.practice || undefined,
              codServizio: values.service || undefined,
            },
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/pratiche/ricerca-responsabile');
      });
    },
    [navigate, updateResponsible]
  );

  return (
    <Fragment>
      <Breadcrumbs items={EditResponsibleCrubs} />
      {responsible.isLoading || responsible.pristine || responsible.hasErrors ? undefined : (
        <FormResponsible
          title="Modifica Responsabile"
          onCancel={onCancel}
          onSubmit={onSubmit}
          isEdit
          initialValues={responsible?.data as FormResponsibleVM}
        />
      )}
    </Fragment>
  );
};

EditResponsible.displayName = 'Edit Responsible Page component';

export default EditResponsible;
